import { Circle } from "lucide-react";
import { initials } from "@/lib/format";
import type { TableroBadge } from "./types";

type Props = {
  badge: TableroBadge;
  asesor?: string;
};

const QuienAtiendeBadge = ({ badge, asesor }: Props) => {
  const cls = "inline-flex items-center gap-1.5 text-xs";
  switch (badge) {
    case "ia-active":
      return (
        <span className={cls}>
          <span className="relative inline-flex h-2 w-2">
            <span className="absolute inset-0 animate-ping rounded-full bg-success opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-success" />
          </span>
          <span className="text-neutral-600">IA conversando</span>
        </span>
      );
    case "ia-waiting":
      return (
        <span className={cls}>
          <Circle className="h-2 w-2 fill-neutral-300 text-neutral-300" />
          <span className="text-neutral-600">IA esperando</span>
        </span>
      );
    case "api":
      // OTP/auth lead delivered via the merchant API — no one is "attending" it, so
      // the badge names the channel instead of implying an AI or advisor is on it.
      return (
        <span className={cls}>
          <Circle className="h-2 w-2 fill-neutral-300 text-neutral-300" />
          <span className="text-neutral-600">API</span>
        </span>
      );
    case "human-active":
      return (
        <span className={cls}>
          <span className="flex h-4 w-4 items-center justify-center rounded-full bg-palomma-primary text-[9px] font-semibold text-white">
            {asesor ? initials(asesor) : "A"}
          </span>
          <span className="truncate text-neutral-600">{asesor ?? "Asesor"} atendiendo</span>
        </span>
      );
  }
};

export default QuienAtiendeBadge;
